import {Table, TablePredicateProps} from '@components/mantine';
import {Framework} from '@core/debug';
import {FunctionComponent} from 'react';

interface FrameworkPredicateProps extends Pick<TablePredicateProps, 'classNames'> {
    frameworks: Framework[];
}

export const FrameworkPredicate: FunctionComponent<FrameworkPredicateProps> = ({frameworks, ...props}) => (
    <Table.Predicate
        {...props}
        id="framework"
        data={[{value: '', label: 'All'}, ...frameworks.map((framework) => ({value: framework, label: framework}))]}
        label="Framework"
    />
);
